import { ISelect } from "@interfaces/Shared/select";
import CloseIcon from "mdi-react/CloseIcon";
import { useEffect } from "react";
import { Field, useForm, useFormState } from "react-final-form";
import styles from "./SelectedArtistsDisplay.module.scss";

interface ISelectedArtistDisplay {
  initialArtists?: any;
}

const SelectedArtistDisplay = ({ initialArtists }: ISelectedArtistDisplay) => {
  const { values } = useFormState();
  const form = useForm();

  const selectedArtist = values?.artist;

  useEffect(() => {
    if (selectedArtist) {
      const currentArtists: string[] = values?.artists || [];

      const artistValue = selectedArtist.value;

      if (!currentArtists.includes(artistValue)) {
        form.change("artists", [
          ...currentArtists,
          { value: selectedArtist.value, label: selectedArtist.label },
        ]);

        form.change("artist", null);
      }
    }
  }, [selectedArtist, form, values?.artists]);

  useEffect(() => {
    if (!initialArtists) {
      return;
    }

    form.change("artists", initialArtists);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeArtist = (index: number): void => {
    const currentArtists = [...(values?.artists || [])];
    currentArtists.splice(index, 1);
    form.change("artists", currentArtists);
  };

  return (
    <div className={styles.selectedArtistsDisplay}>
      <h4>Selected Artists</h4>
      <div className={styles.artistsList}>
        {values?.artists && values.artists.length > 0 ? (
          <ul>
            {values.artists.map((artist: ISelect, index: number) => (
              <li key={index}>
                {artist.label}
                <button
                  type="button"
                  onClick={() => removeArtist(index)}
                  className={styles.removeButton}
                >
                  <CloseIcon />
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <div>No artists selected</div>
        )}
      </div>

      <Field name="artists" component="input" type="hidden" />
    </div>
  );
};

export default SelectedArtistDisplay;
